export default __webpack_public_path__ + "static/Fish_Net-cdca3688a070dc846334b09392533e20.png";